import { createAction } from '@reduxjs/toolkit';
import {
    AgreementPriceDto,
    ExternalPricelistDto,
    PricelistDto,
    UserGroupPermissionDto
} from '../PricePrgClient';
import { CommentUpdatedNotification } from './signalrTypes';

export const startSignalrHubs = createAction('@signalr/startSignalrHubs');

/** Sends out a signalr notification to ALL (including self) clients that price plans has been updated */
export const notifyPricePlansUpdated = createAction<{
    pricelistId: number;
    productId: number;
}>('@signalr/notifyPricePlansUpdated');

/** Sends out a signalr notification to OTHER clients that a user group has been saved (Created/Updated) */
export const notifyUserGroupSaved = createAction<number>('@signalr/notifyUserGroupSaved');

/** Sends out a signalr notification to OTHER clients that members has been added to a user group */
export const notifyUserGroupMembersAdded = createAction<{ userGroupId: number; userIds: number[] }>(
    '@signalr/notifyUserGroupMembersAdded'
);

/** Sends out a signalr notification to OTHER clients that a member has been removed from a user group */
export const notifyUserGroupMemberRemoved = createAction<{ userGroupId: number; userId: number }>(
    '@signalr/notifyUserGroupMemberRemoved'
);

/** Sends out a signalr notification to affected clients that they received a new user group permission */
export const notifyUserGroupPermissionSet = createAction<UserGroupPermissionDto>(
    '@signalr/notifyUserGroupPermissionSet'
);

/** Sends out a signalr notification to affected clients that they received new user group permissions */
export const notifyUserGroupPermissionsSet = createAction<UserGroupPermissionDto[]>(
    '@signalr/notifyUserGroupPermissionsSet'
);

/** Sends out a signalr notification to affected clients that a user group has been removed */
export const notifyUserGroupRemoved = createAction<number>('@signalr/notifyUserGroupRemoved');

/** Sends out a signalr notification to OTHER clients that a pricelist has been created. */
export const notifyPricelistCreated = createAction<PricelistDto>('@signalr/notifyPricelistCreated');

/** Sends out a signalr notification to OTHER clients that a pricelist has been updated. */
export const notifyPricelistUpdated = createAction<number>('@signalr/notifyPricelistUpdated');

/** Sends out a signalr notification to OTHER clients that a pricelist has been deleted. */
export const notifyPricelistDeleted = createAction<number>('@signalr/notifyPricelistDeleted');

/** Sends out a signalr notification to ALL clients that prices has been recalculated for the supplied pricelist id */
export const notifyPricesRecalculated = createAction<number>('@signalr/notifyPricesRecalculated');

/** Sends out a signalr notification to OTHER clients that an external price has been updated */
export const notifyExternalPriceUpdated = createAction<number>('@signalr/notifyExternalPriceUpdated');

/** Sends out a signalr notification to OTHER clients that an external pricelist has been created. */
export const notifyExternalPricelistCreated = createAction<ExternalPricelistDto>(
    '@signalr/notifyExternalPricelistCreated'
);

/** Sends out a signalr notification to OTHER clients that an external pricelist has been deleted. */
export const notifyExternalPricelistDeleted = createAction<number>('@signalr/notifyExternalPricelistDeleted');

/** Sends out a signalr notification to OTHER clients that a price comment has been updated */
export const notifyPriceCommentUpdated = createAction<CommentUpdatedNotification>(
    '@signalr/notifyPriceCommentUpdated'
);

/** Sends out a signalr notification to OTHER clients that appsettings has been updated. */
export const notifyAppSettingsUpdated = createAction('@signalr/notifyAppSettingsUpdated');

/** Sends out a signalr notification to OTHER clients that appsettings has been updated. */
export const notifyWarehouseUpdated = createAction<number>('@signalr/notifyWarehouseUpdated');

/** Sends out a signalr notification to OTHER clients that an agreement price has been saved */
export const notifyAgreementPriceSaved = createAction<number>('@signalr/notifyAgreementPriceSaved');

/** Sends out a signalr notification to OTHER clients that an agreement price has been saved */
export const notifyAgreementPriceDeleted = createAction<AgreementPriceDto>(
    '@signalr/notifyAgreementPriceDeleted'
);

/** Sends out a signalr notification to OTHER clients that an agreement has been saved */
export const notifyAgreementSaved = createAction<number>('@signalr/notifyAgreementSaved');

/** Sends out a signalr notification to OTHER clients that an agreement has been deleted */
export const notifyAgreementDeleted = createAction<number>('@signalr/notifyAgreementDeleted');

/** Sends out a signalr notification to OTHER clients that a customer has been updated */
export const notifyCustomerUpdated = createAction<number>('@signalr/notifyCustomerUpdated');

/** Sends out a signalr notification to OTHER clients that an external pricelist has been updated. */
export const notifyExternalPricelistUpdated = createAction<number>('@signalr/notifyExternalPricelistUpdated');

/** Sends out a signalr notification to OTHER clients that a price has been activated/inactivated */
export const notifyPriceActivated = createAction<number>('@signalr/notifyPriceActivated');

/** Sends out a signalr notification to OTHER clients that a product has been updated */
export const notifyProductUpdated = createAction<number>('@signalr/notifyProductUpdated')